<template>
    <div>
        <div class="white-box-container smp-component-width text-left">
            <h3
                style="font-weight: bold;"
            >
                Group Device Software
            </h3>

            <p style="margin-top: 2rem;">View bulk uploaded devices and their software installed</p>
            <ProductDeviceGroupComponent 
                style="margin-top: 3rem;" 
                :disable_all="disable_all"
                :remove_group_selected="remove_group_selected" 
                @changed-product="changedProduct"
                @changed-group="changedGroup"/>
            <b-alert variant="warning"
                dismissible
                :show="selected_group == 'default'" >The default group cannot be deleted
            </b-alert>

            <b-btn :disabled="selected_group == null || disable_all || selected_group == 'default' || is_deleting" variant="danger" v-b-modal.modal-delete-device>
                <i  v-show="is_deleting" class="fa fa-spinner fa-spin"></i> Delete Group
            </b-btn>

            <div v-if="is_loading_devices">
                <i style="margin-right: 1rem; margin-top: 2rem;" class="fa fa-spinner fa-spin"></i>Loading devices...
            </div>

            <div v-if="device_list.length > 0" class="form-group" style="margin-top: 2rem;">
                <label>Devices</label>
                <div style="margin-top: 0.5rem; margin-bottom: 1rem;">
                    <b-table id="items-table" outlined bordered
                        :items="device_list"
                        :fields="fields">
                    </b-table>
                </div>
            </div>
        </div>

        <b-modal
            centered
            id="modal-delete-device"
            ref="modal-delete-device"
            title="Confirm Delete"
            cancel-title="Confirm Delete"
            cancel-variant="danger"
            ok-title="Cancel"
            @cancel="clickedDelete"
        >
        <p>Are you sure you want to delete this groups and the devices associated to it?</p>
        </b-modal>

    </div>
</template>

<script>
import ProductDeviceGroupComponent from '../../components/ProductDeviceGroupComponent.vue'

import DEVICE_API from '../../api/device'
import DEVICE_GROUP_API from '../../api/device_group'

import UTILS from '../../utils'

export default {

	components: {
        ProductDeviceGroupComponent
	},
  	data () {
		return {
            remove_group_selected: false,
            is_button_disabled: true,

            disable_all: false,

            selected_product: null,
            selected_group: null,

            is_loading_devices: false,

            is_deleting: false,

            device_list: [],
            fields: [
                { key: 'serialnumber', label: 'Serial', sortable: true },
                { key: 'current_sw', label:'Current Software', sortable: true }
            ],
		}
	},

	watch: {

	},

	mounted () {
		console.log('GroupDeviceSoftware mounted')
	},

	methods: {
        changedProduct: function(newProduct) {
            console.debug("changedProduct: ", newProduct)

            this.selected_product = newProduct
            this.selected_group = null
        },

        changedGroup: function(newGroup) {
            console.debug("changedGroup: ", newGroup)

            if (newGroup != null) {
                this.selected_group = newGroup
                this.loadDevices();
            } else if (this.device_list.length > 0) {
                this.device_list = []
            }
        },

        loadDevices: function() {
            console.debug('loadDevices')

            this.is_loading_devices = true;

            const params = {
                params: {
                    product_name: this.selected_product,
                    device_group_name: this.selected_group    
                }
            }

            const reference = this

            this.disable_all = true
            this.device_list = [];

            DEVICE_API.get(params,
                (response) => {
                    if (response.length > 0) {
                        this.device_list = response
                    } else {
                        UTILS.makeToast(reference.$bvToast, "Warning", "warning", "There isn't any device for this product and group");
                    }

                    reference.disable_all = false;

                    reference.is_loading_devices = false;
                },
                (e) => {
                    console.debug("DEVICE_API.get() ", e)

                    reference.disable_all = false;

                    reference.is_loading_devices = false;

                    UTILS.makeToast(reference.$bvToast, "Error", "danger", "The devices couldn't be loaded");
                }
            )
        },

        clickedDelete: function() {
            this.is_deleting = true
            this.disable_all = true

            this.deleteGroup()
        },

        deleteGroup: function() {
            console.debug('deleteGroup')

            const params = {
                params : {
                    product_name: this.selected_product,
                    device_group_name: this.selected_group
                }
            }

            const reference = this

            DEVICE_GROUP_API.delete(params,
                () => {
                    reference.remove_group_selected = !reference.remove_group_selected

                    reference.disable_all = false
                    reference.is_deleting = false

                    UTILS.makeToast(reference.$bvToast, "Success", "success", 'The group and its devices have been deleted')
                },
                e => {
                    console.debug(e);

                    reference.disable_all = false
                    reference.is_deleting = false

                    UTILS.makeToast(reference.$bvToast, "Error", "danger", 'There was a problem deleting the group')
                }
            );
        }
	}
}
</script>

<style lang="stylus" scoped>

</style>